import api from './api';

export const getBancolombiaCredentials = async () => {
    const response = await api.get('/wallet/bancolombia-credentials');
    return response.data;
};

export const saveBancolombiaCredentials = async (data) => {
    const response = await api.post('/wallet/bancolombia-credentials', data);
    return response.data;
};

export const requestSyncBancolombia = async () => {
    const response = await api.post('/wallet/sync-bancolombia/request');
    return response.data;
};

export const getBancolombiaSyncStatus = async () => {
    const response = await api.get('/wallet/sync-bancolombia/status');
    return response.data;
};

export const cancelSyncBancolombia = async () => {
    const response = await api.post('/wallet/sync-bancolombia/cancel');
    return response.data;
};

export const uploadBancolombiaCSV = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/wallet/bancolombia/upload-csv', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getBancolombiaMovements = async (limit = 100, offset = 0, filters = {}) => {
    const { startDate, endDate, status } = filters;
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);

    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (status) params.append('status', status);
    if (filters.linkedSearch) params.append('linkedSearch', filters.linkedSearch);
    if (filters.orderNumber) params.append('orderNumber', filters.orderNumber);
    if (filters.amount) params.append('amount', filters.amount);
    if (filters.customerName) params.append('customerName', filters.customerName);
    if (filters.search) params.append('search', filters.search);
    if (filters.tag) params.append('tag', filters.tag);

    const response = await api.get(`/wallet/bancolombia/movements?${params.toString()}`);
    return response.data;
};

export const getBancolombiaStats = async () => {
    const response = await api.get('/wallet/bancolombia/stats');
    return response.data;
};

export const linkOrderToMovement = async (movementId, orderId, reconciliationOnly = false) => {
    const response = await api.put(`/wallet/movements/${movementId}/link-order`, {
        pedido_id: orderId,
        ...(reconciliationOnly && { reconciliation_only: true })
    });
    return response.data;
};

export const linkExpenseToMovement = async (movementId, expenseId) => {
    const response = await api.put(`/wallet/movements/${movementId}/link-expense`, {
        expense_id: expenseId
    });
    return response.data;
};

export const tagMovement = async (movementId, tag) => {
    const response = await api.put(`/wallet/movements/${movementId}/tag`, { tag });
    return response.data;
};

export const bulkAutoTag = async () => {
    const response = await api.post('/wallet/movements/bulk-auto-tag');
    return response.data;
};

export const searchExpenses = async (q, amount) => {
    const params = new URLSearchParams();
    if (q) params.append('q', q);
    if (amount) params.append('amount', amount);
    const response = await api.get(`/expenses/search?${params.toString()}`);
    return response.data;
};

export const getPendingReconciliation = async (params = {}) => {
    const { page = 1, limit = 10, search = '' } = params;
    console.log('🌐 [WALLET-SERVICE] Building API call with:', { page, limit, search });
    const queryParams = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
    if (search) {
        queryParams.append('search', search);
    }
    const url = `/wallet/pending-reconciliation?${queryParams.toString()}`;
    console.log('🌐 [WALLET-SERVICE] API URL:', url);
    const response = await api.get(url);
    console.log('🌐 [WALLET-SERVICE] API Response data length:', response.data?.data?.length);
    return response.data;
};

export const linkMovementToOrder = async (orderId, movementId) => {
    const response = await api.post('/wallet/link-movement', {
        orderId,
        movementId
    });
    return response.data;
};

// NUEVO: Método faltante para obtener pedidos de cartera
export const getWalletOrders = async (filters = {}) => {
    const params = new URLSearchParams();

    // Mapear filtros a query params
    Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
            params.append(key, filters[key]);
        }
    });

    // Asegurar que include_logistica_pending se envíe como string 'true' si es booleano
    if (filters.include_logistica_pending) {
        params.set('include_logistica_pending', 'true');
    }

    const response = await api.get(`/wallet/orders?${params.toString()}`);
    return response.data;
};

export const getPaymentEvidences = async (orderId) => {
    const response = await api.get(`/wallet/payment-evidences/${orderId}`);
    return response.data;
};

export const getLinkedPayments = async (orderId) => {
    const response = await api.get(`/wallet/orders/${orderId}/linked-payments`);
    return response.data;
};

export const getOrderPayments = async (orderId) => {
    const response = await api.get(`/orders/${orderId}/payments`);
    return response.data;
};

export const getOrderVouchers = async (orderId) => {
    const response = await api.get(`/wallet/orders/${orderId}/vouchers`);
    return response.data;
};

export default {
    getBancolombiaCredentials,
    saveBancolombiaCredentials,
    requestSyncBancolombia,
    getBancolombiaSyncStatus,
    cancelSyncBancolombia,
    uploadBancolombiaCSV,
    getBancolombiaMovements,
    getBancolombiaStats,
    linkOrderToMovement,
    linkExpenseToMovement,
    tagMovement,
    bulkAutoTag,
    searchExpenses,
    getPendingReconciliation,
    linkMovementToOrder,
    getWalletOrders,
    getPaymentEvidences,
    getLinkedPayments,
    getOrderPayments,
    getOrderVouchers
};
